import { post } from 'libs/GrebbCommerceAPI/util';

export default async (basketId, data) => {
    return await post(`/basket/${basketId}/payment-callback`, data);
};
